/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ScorecardCurrentSnapshotOut } from '../models/ScorecardCurrentSnapshotOut';
import type { ScorecardMetricDirectionOut } from '../models/ScorecardMetricDirectionOut';
import type { ScorecardMetricDirectionsResponse } from '../models/ScorecardMetricDirectionsResponse';
import type { ScorecardMetricDirectionUpdate } from '../models/ScorecardMetricDirectionUpdate';
import type { ScorecardResponse } from '../models/ScorecardResponse';
import type { ScorecardSnapshotNotesOut } from '../models/ScorecardSnapshotNotesOut';
import type { ScorecardSnapshotNotesUpdate } from '../models/ScorecardSnapshotNotesUpdate';
import type { ScorecardSnapshotsResponse } from '../models/ScorecardSnapshotsResponse';
import type { ScorecardSnapshotSummaryOut } from '../models/ScorecardSnapshotSummaryOut';
import type { ScorecardSnapshotSummaryUpdate } from '../models/ScorecardSnapshotSummaryUpdate';
import type { ScorecardWorkstreamCommentSave } from '../models/ScorecardWorkstreamCommentSave';
import type { ScorecardWorkstreamUpdateOut } from '../models/ScorecardWorkstreamUpdateOut';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ScorecardsService {

    /**
     * Save Scorecard Workstream Update
     * @param workstreamId
     * @param requestBody
     * @returns ScorecardWorkstreamUpdateOut Successful Response
     * @throws ApiError
     */
    public static saveScorecardWorkstreamUpdateApiV1ScorecardsWorkstreamUpdatesWorkstreamIdPut(
        workstreamId: number,
        requestBody: ScorecardWorkstreamCommentSave,
    ): CancelablePromise<ScorecardWorkstreamUpdateOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/scorecards/workstream-updates/{workstream_id}',
            path: {
                'workstream_id': workstreamId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Scorecard Snapshots
     * @returns ScorecardSnapshotsResponse Successful Response
     * @throws ApiError
     */
    public static scorecardSnapshotsApiV1ScorecardsSnapshotsGet(): CancelablePromise<ScorecardSnapshotsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/scorecards/snapshots',
        });
    }

    /**
     * Ensure Current Scorecard Metric Snapshot
     * @param metricId
     * @returns ScorecardCurrentSnapshotOut Successful Response
     * @throws ApiError
     */
    public static ensureCurrentScorecardMetricSnapshotApiV1ScorecardsMetricsMetricIdCurrentSnapshotPost(
        metricId: number,
    ): CancelablePromise<ScorecardCurrentSnapshotOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/scorecards/metrics/{metric_id}/current-snapshot',
            path: {
                'metric_id': metricId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Scorecard Snapshot Notes
     * @param snapshotId
     * @param requestBody
     * @returns ScorecardSnapshotNotesOut Successful Response
     * @throws ApiError
     */
    public static updateScorecardSnapshotNotesApiV1ScorecardsSnapshotsSnapshotIdNotesPut(
        snapshotId: number,
        requestBody: ScorecardSnapshotNotesUpdate,
    ): CancelablePromise<ScorecardSnapshotNotesOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/scorecards/snapshots/{snapshot_id}/notes',
            path: {
                'snapshot_id': snapshotId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Scorecard Snapshot Summary
     * @param requestBody
     * @returns ScorecardSnapshotSummaryOut Successful Response
     * @throws ApiError
     */
    public static updateScorecardSnapshotSummaryApiV1ScorecardsSnapshotSummaryPut(
        requestBody: ScorecardSnapshotSummaryUpdate,
    ): CancelablePromise<ScorecardSnapshotSummaryOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/scorecards/snapshot-summary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Scorecards
     * @param snapshotDt
     * @returns ScorecardResponse Successful Response
     * @throws ApiError
     */
    public static scorecardsApiV1ScorecardsGet(
        snapshotDt?: (string | null),
    ): CancelablePromise<ScorecardResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/scorecards',
            query: {
                'snapshot_dt': snapshotDt,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Scorecard Metric Directions
     * List the metrics this admin sees on Scorecards, with their directions.
     * @returns ScorecardMetricDirectionsResponse Successful Response
     * @throws ApiError
     */
    public static listScorecardMetricDirectionsApiV1AdminScorecardsMetricDirectionsGet(): CancelablePromise<ScorecardMetricDirectionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/scorecards/metric-directions',
        });
    }

    /**
     * Update Scorecard Metric Direction
     * @param metricId
     * @param requestBody
     * @returns ScorecardMetricDirectionOut Successful Response
     * @throws ApiError
     */
    public static updateScorecardMetricDirectionApiV1AdminScorecardsMetricDirectionsMetricIdPut(
        metricId: number,
        requestBody: ScorecardMetricDirectionUpdate,
    ): CancelablePromise<ScorecardMetricDirectionOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/scorecards/metric-directions/{metric_id}',
            path: {
                'metric_id': metricId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
